import React, { useState } from "react";
import { Button, Col, Navbar, Row } from "react-bootstrap";
import { Link } from 'react-router-dom';
import logoLight from "../../logo1.png";
import logoDark from "../../white1.png";
import SearchIcon from "@material-ui/icons/Search";
import SidebarOption from "../SidebarOption/sidebaroption";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import BookmarkBorderIcon from "@material-ui/icons/BookmarkBorder";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import './sidebar.css';
import HomeIcon from "@material-ui/icons/Home";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";

function Sidebar({ isDarkMode, toggleTheme }) {
    const [showSidebar, setShowSidebar] = useState(true); // Default to show sidebar on larger screens
    const [showOptions, setShowOptions] = useState(false);

    // Function to handle logout
    const handleLogout = () => {
        console.log("User logged out");
        // Redirect to the login page
        window.location.href = "/login";
    };

    return (
        <div>
            {/* Sidebar container */}
            <Row className={`justify-content-center ${showSidebar ? "sidebar-open" : "sidebar-closed"} d-none d-md-flex flex-column align-items-center`}>
                <Col sm={2} className={`sidebar ${isDarkMode ? 'dark-mode' : 'light-mode'}`} style={{ backgroundColor: isDarkMode ? '#333' : '#f8f9fa' }}>
                    {/* Logo */}
                    <Link to="/" className="nav-link">
                        {isDarkMode ? (
                            <img src={logoDark} alt="Dark Mode Logo" className="logo" style={{ width: '100%', marginTop:'-4%' , marginLeft:'-3%' }} />
                        ) : (
                            <img src={logoLight} alt="Light Mode Logo" className="logo1" style={{ width: '100%', marginTop:'-4%' , marginLeft:'-3%' }} />
                        )}
                    </Link>

                    {/* Sidebar options */}
                    <Link to="/" className={`nav-link AJ sidebar-link ${isDarkMode ? 'text-light' : 'text-dark'}`} onClick={() => setShowOptions(false)}>
                        <HomeIcon className="sidebar-icon" style={{ fontSize: '30px' }} /> <span className="sidebar-text" style={{ fontSize: '15px' }}>Home</span>
                    </Link>
                    <Link to="/search" className={`nav-link AJ sidebar-link ${isDarkMode ? 'text-light' : 'text-dark'}`} onClick={() => setShowOptions(false)}>
                        <SearchIcon className="sidebar-icon" style={{ fontSize: '30px' }} /> <span className="sidebar-text" style={{ fontSize: '15px' }}>Search</span>
                    </Link>
                    <Link to="/bookmark" className={`nav-link AJ sidebar-link ${isDarkMode ? 'text-light' : 'text-dark'}`} onClick={() => setShowOptions(false)}>
                        <BookmarkBorderIcon className="sidebar-icon" style={{ fontSize: '30px' }} /> <span className="sidebar-text" style={{ fontSize: '15px' }}>Bookmark</span>
                    </Link>
                    <Link to="/contact" className={`nav-link AJ sidebar-link ${isDarkMode ? 'text-light' : 'text-dark'}`} onClick={() => setShowOptions(false)}>
                        <MailOutlineIcon className="sidebar-icon" style={{ fontSize: '30px' }} /> <span className="sidebar-text" style={{ fontSize: '15px' }}>Contact</span>
                    </Link>
                    <Link to="/aboutus" className={`nav-link AJ sidebar-link ${isDarkMode ? 'text-light' : 'text-dark'}`} onClick={() => setShowOptions(false)}>
                        <MoreHorizIcon className="sidebar-icon" style={{ fontSize: '30px' }} /> <span className="sidebar-text" style={{ fontSize: '15px' }}>About Us</span>
                    </Link>
                    <Link to="/login" className={`nav-link AJ sidebar-link ${isDarkMode ? 'text-light' : 'text-dark'}`} onClick={() => { handleLogout(); setShowOptions(false); }}>
                        <ExitToAppIcon className="sidebar-icon" style={{ fontSize: '30px' }} /> <span className="sidebar-text" style={{ fontSize: '15px'}}>Logout</span>
                    </Link>
                </Col>
            </Row>
        </div>
    );
}

export default Sidebar;
